import React from 'react';
import gpt3Logo from '../../assets/logo67.jpg';
import './footer.css';

const Footer = () => (
  <div className="gpt3__footer section__padding">
    <div className="gpt3__footer-heading">
      <h1 className="gradient__text">Learn Advanced Gym Workout Techniques</h1>
    </div>

    <div className="gpt3__footer-btn">
      <p>Learn Workout Techniques</p>
    </div>

    <div className="gpt3__footer-links">
      <div className="gpt3__footer-links_logo">
        <img src={gpt3Logo} alt="gpt3_logo" />
        <p>122 Ellwood Lane, Ellwood <br /> All Rights Reserved</p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Links</h4>
        <p>Overons</p>
        <p>Social Media</p>
        <p>Counters</p>
        <p>Contact</p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Company</h4>
        <p>Terms & Conditions </p>
        <p>Privacy Policy</p>
        <p>Contact</p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Get in touch</h4>
        <p>122 Ellwood Lane</p>
        <p>6674-32487</p>
        <p>info@fitnessgym.net</p>
      </div>
    </div>

    <div className="gpt3__footer-copyright">
      <p>@2023 GymWorld. All rights reserved.</p>
    </div>
  </div>
);

export default Footer;
